import React from "react";
import Lottie from "react-lottie";
import Gears from "../lotties/gears.json";

export default function Projects() {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: Gears,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <div className="mt-24 mb-2 px-16 flex-grow flex flex-row">
      <div className="flex-1 flex items-center justify-center">
        <div>
          <Lottie options={defaultOptions} />
        </div>
      </div>
    </div>
  );
}
